import { yupResolver } from '@hookform/resolvers/yup';
import React, { memo, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useForm } from 'react-hook-form';

import Loader from "react-js-loader";
import { ToastContainer, toast } from 'react-toastify';
import * as Yup from 'yup';
import { getEndpointUrl } from "../../Utils/Common";

const CreateSection = ({ onCallback, show, close }) => {

    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [accesToken, setAccessToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    useEffect(() => {
        // no-op; mirror CreatePelanggan structure
    }, [isLoading]);

    const validationSchema = Yup.object().shape({
        title: Yup.string().required('Field harus diisi')
    });

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = data => {
        setLoading(true);

        const formData = new FormData();
        formData.append('title', data.title);
        if (data.icon && data.icon[0]) {
            formData.append('icon', data.icon[0]);
        }

        fetch(getEndpointUrl() + '/v2/form_sections', {
            method: "POST",
            body: formData,
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            setLoading(false);

            if (json.status === 'ok') {
                toast.success("Yay, Form section berhasil diinput.", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                });

                close();
                onCallback(json.results);
                reset();

            } else {
                toast.error(json.message || "Gagal menyimpan section.", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true
                });
            }
        }).catch(error => {
            setLoading(false);
            toast.error("Terjadi kesalahan jaringan.", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
        });
    };

    return (
        <>
            <ToastContainer position="top-end" className="p-3"></ToastContainer>
            <Modal show={show} onHide={close} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{isLoading ? "Menyimpan data..." : "Input form section"}</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    {isLoading ?
                        <Modal.Body>
                            <div className="d-flex justify-content-center mt-5 mb-5">
                                <Loader type="bubble-scale" bgColor={"#42A5F5"} size={100} />
                            </div>
                        </Modal.Body>
                        :
                        <>
                            <Modal.Body>
                                <Form.Group className="mb-3" controlId="formSectionTitle">
                                    <Form.Label>Nama section</Form.Label>
                                    <Form.Control type="text" {...register("title")} isInvalid={errors.title ? true : false} autoComplete="off" placeholder="Nama Komponen" />
                                </Form.Group>

                                {/* Tambahkan input file icon */}
                                <Form.Group className="mb-3" controlId="formSectionIconCreate">
                                    <Form.Label>Icon (opsional)</Form.Label>
                                    <Form.Control type="file" accept="image/*" {...register("icon")} />
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={close}> Batal </Button>
                                <Button variant="success" type="submit">Input form section</Button>
                            </Modal.Footer>
                        </>
                    }
                </Form>
            </Modal>
        </>
    );
}

export default memo(CreateSection);